/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Verdict assigned to this chat ops action
 * @export
 */
export const ControlVerdict = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict = typeof ControlVerdict[keyof typeof ControlVerdict];


export function ControlVerdictFromJSON(json: any): ControlVerdict {
    return ControlVerdictFromJSONTyped(json, false);
}

export function ControlVerdictFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict {
    return json as ControlVerdict;
}

export function ControlVerdictToJSON(value?: ControlVerdict | null): any {
    return value as any;
}

